// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsArea/style.css
// module id = 3704
// module chunks = 29